import { render } from "./NetworkInteractionComponent.vue?vue&type=template&id=be0ac436&scoped=true"
import script from "./NetworkInteractionComponent.vue?vue&type=script&lang=js"
export * from "./NetworkInteractionComponent.vue?vue&type=script&lang=js"

import "./NetworkInteractionComponent.vue?vue&type=style&index=0&id=be0ac436&scoped=true&lang=css"

import exportComponent from "/home/n3rdy/dev/virtuallab-networksecurity/exp-5/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be0ac436"]])

export default __exports__